
export default {
  name: 'HelpCenter',
  components: {},
  mixins: [],
  props: [],
  asyncData: {},
  data() {
    return {
      faqQuestion: [
        {
          title: this.$t('helpCenterPage.faqList.question.title0'),
          desc: this.$t('helpCenterPage.faqList.question.desc0'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title1'),
          desc: this.$t('helpCenterPage.faqList.question.desc1'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title2'),
          desc: this.$t('helpCenterPage.faqList.question.desc2'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title3'),
          desc: this.$t('helpCenterPage.faqList.question.desc3'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title4'),
          desc: this.$t('helpCenterPage.faqList.question.desc4'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title5'),
          desc: this.$t('helpCenterPage.faqList.question.desc5'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title6'),
          desc: this.$t('helpCenterPage.faqList.question.desc6'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title7'),
          desc: this.$t('helpCenterPage.faqList.question.desc7'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title8'),
          desc: this.$t('helpCenterPage.faqList.question.desc8'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title9'),
          desc: this.$t('helpCenterPage.faqList.question.desc9'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title10'),
          desc: this.$t('helpCenterPage.faqList.question.desc10'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title11'),
          desc: this.$t('helpCenterPage.faqList.question.desc11'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title12'),
          desc: this.$t('helpCenterPage.faqList.question.desc12'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title13'),
          desc: this.$t('helpCenterPage.faqList.question.desc13'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title14'),
          desc: this.$t('helpCenterPage.faqList.question.desc14'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title15'),
          desc: this.$t('helpCenterPage.faqList.question.desc15'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title16'),
          desc: this.$t('helpCenterPage.faqList.question.desc16'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title17'),
          desc: this.$t('helpCenterPage.faqList.question.desc17'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title18'),
          desc: this.$t('helpCenterPage.faqList.question.desc18'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title19'),
          desc: this.$t('helpCenterPage.faqList.question.desc19'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title20'),
          desc: this.$t('helpCenterPage.faqList.question.desc20'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title21'),
          desc: this.$t('helpCenterPage.faqList.question.desc21'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title22'),
          desc: this.$t('helpCenterPage.faqList.question.desc22'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title23'),
          desc: this.$t('helpCenterPage.faqList.question.desc23'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title24'),
          desc: this.$t('helpCenterPage.faqList.question.desc24'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title25'),
          desc: this.$t('helpCenterPage.faqList.question.desc25'),
        },
      ],
      filterData: [
        {
          title: this.$t('helpCenterPage.faqList.question.title0'),
          desc: this.$t('helpCenterPage.faqList.question.desc0'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title1'),
          desc: this.$t('helpCenterPage.faqList.question.desc1'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title2'),
          desc: this.$t('helpCenterPage.faqList.question.desc2'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title3'),
          desc: this.$t('helpCenterPage.faqList.question.desc3'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title4'),
          desc: this.$t('helpCenterPage.faqList.question.desc4'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title5'),
          desc: this.$t('helpCenterPage.faqList.question.desc5'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title6'),
          desc: this.$t('helpCenterPage.faqList.question.desc6'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title7'),
          desc: this.$t('helpCenterPage.faqList.question.desc7'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title8'),
          desc: this.$t('helpCenterPage.faqList.question.desc8'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title9'),
          desc: this.$t('helpCenterPage.faqList.question.desc9'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title10'),
          desc: this.$t('helpCenterPage.faqList.question.desc10'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title11'),
          desc: this.$t('helpCenterPage.faqList.question.desc11'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title12'),
          desc: this.$t('helpCenterPage.faqList.question.desc12'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title13'),
          desc: this.$t('helpCenterPage.faqList.question.desc13'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title14'),
          desc: this.$t('helpCenterPage.faqList.question.desc14'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title15'),
          desc: this.$t('helpCenterPage.faqList.question.desc15'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title16'),
          desc: this.$t('helpCenterPage.faqList.question.desc16'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title17'),
          desc: this.$t('helpCenterPage.faqList.question.desc17'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title18'),
          desc: this.$t('helpCenterPage.faqList.question.desc18'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title19'),
          desc: this.$t('helpCenterPage.faqList.question.desc19'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title20'),
          desc: this.$t('helpCenterPage.faqList.question.desc20'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title21'),
          desc: this.$t('helpCenterPage.faqList.question.desc21'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title22'),
          desc: this.$t('helpCenterPage.faqList.question.desc22'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title23'),
          desc: this.$t('helpCenterPage.faqList.question.desc23'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title24'),
          desc: this.$t('helpCenterPage.faqList.question.desc24'),
        },
        {
          title: this.$t('helpCenterPage.faqList.question.title25'),
          desc: this.$t('helpCenterPage.faqList.question.desc25'),
        },
      ],
    }
  },
  head() {
    return {
      title: 'Enifex : Help Center',
    }
  },
  computed: {},
  mounted() {},
  methods: {
    questionResult(value) {
      if (value) {
        this.faqQuestion = this.faqQuestion.filter((item) => {
          return item.title.toUpperCase().includes(value.toUpperCase())
        })
        // const data = []
        // this.faqQuestion.forEach((elem) => {
        //   if (elem.title.toUpperCase().includes(value.toUpperCase())) {
        //     data.push(elem)
        //   }
        // })
        // this.faqQuestion = data
      } else {
        this.faqQuestion = this.filterData
      }
    },
  },
}
